import { createSlice } from '@reduxjs/toolkit';
// @types
import {
  LocalSettingsState
} from '../../@types/localSettings';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const endDate = new Date();

const startDate = new Date();
startDate.setDate(new Date().getDate() - 30);

const initialState: LocalSettingsState = {
  startDate: startDate.toISOString(),
  endDate: endDate.toISOString()
};

const slice = createSlice({
  name: 'localSettings',
  initialState,
  reducers: {
    setGlobalStartDateReducer(state, action) {
      state.startDate = action.payload;
    },
    setGlobalEndDateReducer(state, action) {
      state.endDate = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export function setStartDate(date: string | Date) {
  if (typeof date === 'string') {
    dispatch(slice.actions.setGlobalStartDateReducer(date));
  } else {
    dispatch(slice.actions.setGlobalStartDateReducer(date.toISOString()));
  }
}

export function setEndDate(date: string | Date) {
  if (typeof date === 'string') {
    dispatch(slice.actions.setGlobalEndDateReducer(date));
  } else {
    dispatch(slice.actions.setGlobalEndDateReducer(date.toISOString()));
  }
}
